import { Placeholder } from 'react-bootstrap'
import React from 'react'

export const BigLoadingPlaceholder = () => {
  return (
    <div>
      <Placeholder animation="glow">
        <Placeholder md={8} />
        <Placeholder md={7} bg="primary" />
        <Placeholder md={12} size="xs" />
      </Placeholder>
    </div>
  )
}
